// TOP LEVEL IMPORTS
import gql from 'graphql-tag';
import invoiceFragment from 'ApolloClient/Fragments/invoiceFragment';

export default gql`
  fragment contractFragment on Contract {
    _id
    clientId
    contractType
    contractorEmail
    sessionDate
    clientSignature
    clientSignDate
    contractorSignature
    contractorSignDate
    signedByClient
    invoicesCreated
    finalPaymentAmount
    finalPaymentDueDate
    depositDueDate
    #deposit
    depositAmount
    depositValue
    depositType
    #discount
    discountAmount
    discountValue
    discountType
    #other
    status
    sessionDate
    signedByContractor
    termsHTML
    currency
    salesTax
    organization {
      _id
      title
      email
      image
      city
      state
      country
      salesTax
      stripeUserIdExists
    }
    lineItems {
      amount
      description
    }
    invoices {
      ...invoiceFragment
    }
    client {
      _id
      firstName
      lastName
      email
    }
  }
  ${invoiceFragment}
`;



// WEBPACK FOOTER //
// ./src/ApolloClient/Fragments/contractFragment.js